import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  scrollView: {paddingHorizontal: 22, paddingBottom: 100},
  meijerVan: {width: 114, height: 69, marginTop: -15},
  header: {paddingTop: 25},
});
